// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3U56a","footer":"ModalUpdate_footer__31KdH"};